import { render, staticRenderFns } from "./ComingSoon.vue?vue&type=template&id=12821d2b&scoped=true"
import script from "./ComingSoon.vue?vue&type=script&lang=ts"
export * from "./ComingSoon.vue?vue&type=script&lang=ts"
import style0 from "./ComingSoon.vue?vue&type=style&index=0&id=12821d2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12821d2b",
  null
  
)

export default component.exports